import React, { type FC } from 'react';
import List from '@mui/material/List';
import { useLocation } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import NavigationLink from 'src/components/layout/landlord/NavigationLink';
import { PropertiesIcon } from 'src/icons';

import styles from 'src/components/layout/landlord/DesktopNavigationSidebar.module.css';

type Props = {
    onNavigationChange: () => void;
    isSidebarCollapsed?: boolean;
}

export const DesktopNavigationPropertiesLink: FC<Props> = ({ onNavigationChange, isSidebarCollapsed }) => {
    const location = useLocation();
    const isListingsActive = location.pathname.includes('/landlord/inner/properties/listings');

    return (
        <>
            <NavigationLink
                text={'Properties'}
                icon={<PropertiesIcon />}
                link="/landlord/inner/properties"
                onClick={onNavigationChange}
            />
            {!isSidebarCollapsed && (
                <div className={`${styles.subNavItem} ${isListingsActive ? styles.active : ''}`}>
                    <List className={styles.inboxLinks}>
                        <NavigationLink
                            text={'Listings'}
                            icon={<HomeOutlinedIcon />}
                            link="/landlord/inner/properties/listings"
                            onClick={onNavigationChange}
                        />
                    </List>
                </div>
            )}
        </>
    );
};
